<template>
  <v-container>
      <v-row>
        <v-col :class="`d-flex ${filiais.length > 7 ?  'justify-space-between' : ''} flex-wrap`">

          <div v-for="(filial, index) in filiais" :key="index">
            <pm-resumo-dia :filial="filial.cc_fil" :key="filial.id_reg"></pm-resumo-dia>
          </div>

        </v-col>
      </v-row>

  </v-container>
</template>
<script>
import ResumoVendaDia from './ResumoVendaDia.vue'
//import groupBy from 'lodash/groupBy'
export default {
  name: 'Home',

  components: {
    'pm-resumo-dia': ResumoVendaDia
  },

  data(){
    return {

      filiais: [],



    }
  },

  methods: {

    populaFiliais() {
      this.$store.dispatch('obterFiliais', {}).then(resp => {
        this.filiais = resp.data.content
      }).catch(err => {
        console.log(err)
      })
    },
/*
    obterVendasDoDia(){
      this.$store.dispatch('obterTotalFatura', {dt_fat_i:'2020-01-01', dt_fat_f:'2020-01-31'}).then(resp => {
        this.vendasDoDia = resp.data
      }).catch(err => {
        console.log(err)
      })
    },

    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },

    montarVendasDoDiaPorFilial() {
      let dados = []
      this.vendasDoDia.forEach((el) => {
        dados.push(el)
      });

      console.log('dados', dados)

      const pdv = groupBy(dados, function(n){
        return n.cc_fil
      });

      console.log('dados filtrado', pdv)

      let labels = []
      let data = []
      for(let el in pdv) {
        labels.push(el)
        let valor = 0;
        pdv[el].forEach(el2 => {
          valor += el2.vl_fat
        })
        data.push(valor)
      }

      console.log('labels', labels)
      console.log('data', data)

      this.key = Math.random()
      this.chartdata = {
        labels: labels,
        datasets: [{
            label: 'Venda do dia por Empresa',
            data: data,
            height: 200,
            borderWidth: 1
        }]
      };
      this.options = {
        responsive: false,
        maintainAspectRatio: true
      }

    }*/

  },

  mounted(){
    
  },

  created(){
    this.$vuetify.goTo(0)
    this.populaFiliais()
  }

}
</script>